import React from 'react';
import './Review.css'

const Review = () => {
    return (
        <div className="Review-container">
            <h3>This is from review page</h3>
        </div>
    );
};

export default Review;